import { Pager, PagerContainer } from '../simple-styled-components';

interface PagerProps {
  elements: any;
  skip: number;
  take: number;
  handlePageChange: (e: any) => void;
  className?: string;
  paddingTop?: string;
  paddingBottom?: string;
}

/**
 * A styled pagination section component. See usage details at https://www.telerik.com/kendo-react-ui/components/listview/paging/.
 * @param props
 */
const PagerSection = (props: PagerProps) => {
  const {
    elements,
    skip,
    take,
    handlePageChange,
    className = 'tw-pb-3',
    paddingTop,
    paddingBottom,
  } = props;
  return (
    <>
      {elements && elements.length > take ? (
        <PagerContainer
          style={{
            paddingTop: paddingTop ?? '18px',
            paddingBottom: paddingBottom ?? '0px',
          }}
        >
          <Pager
            skip={skip}
            take={take}
            onPageChange={handlePageChange}
            total={elements.length}
            previousNext
            type="numeric"
            info={false}
            buttonCount={3}
          />
        </PagerContainer>
      ) : (
        <div id="pager-hidden" className={`${className}`} />
      )}
    </>
  );
};

export default PagerSection;
